<template>
  <footer class="main-footer">
    <Logo />
    <div class="version"><b>Version</b> 1.0.0</div>
    <div class="copyright">
      <strong
        >Copyright &copy; 2015 - {{ new Date().getFullYear() }}
        <a href="https://www.zeroquest.kr/">For ZeroQuest</a>.</strong
      >
      All rights reserved.
    </div>
  </footer>
</template>

<script lang="ts" setup>
import Logo from "@/components/Application/AppLogo.vue";
</script>

<style lang="scss" scoped>
footer {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #fff;
  // opacity: 0.5;

  .logo {
    display: block;
    margin-bottom: 4px;
  }

  .version {
    margin: 0 10px;
    line-height: 33px;
  }

  .copyright {
    line-height: 33px;
  }
}
@include mobile {
  footer {
    flex-direction: column;
  }
}
@include tabletToMobile {
  footer {
    flex-direction: column;
  }
}
</style>
